export default [
  {
    description: 'disable media rail',
    control: '2310-20',
    treatment: '2310-21',
    ks: 'disableMediaRail',
    devices: ['Desktop', 'Mobile'],
  },
  {
    description: 'best seller',
    control: '2551-20',
    treatment: '2551-21',
    ks: 'bestSellerExperimentEnabled',
    arm: 'topPanelEnabled',
    devices: ['Desktop'],
    invalidationPrefetch: false,
  },
  {
    description: 'best seller',
    control: '2551-20',
    treatment: '2551-22',
    ks: 'bestSellerExperimentEnabled',
    arm: 'bestSellerPanelEnabled',
    devices: ['Desktop'],
    invalidationPrefetch: false,
  },
  {
    description: 'new search-modal',
    control: '2601-20',
    treatment: '2601-21',
    ks: 'newSearchModalEnabled',
    devices: ['Desktop', 'Mobile'],
    invalidationPrefetch: false,
  },
  {
    description: 'scrolly cats',
    control: '2867-20',
    treatment: '2867-21',
    ks: 'scrollyCatsEnabled',
    devices: ['Mobile'],
    invalidationPrefetch: false,
  },
  {
    description: 'Floating Bug Tab GECX',
    control: '2880-20',
    treatment: '2880-21',
    ks: 'aiFloatingActionButtonEnabled',
    devices: ['Desktop', 'Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
  {
    description: 'trending queries (popular searches)',
    control: '2565-20',
    treatment: '2565-21',
    ks: 'popularSearchesEnabled',
    arm: 'popularSearchesArm1',
    devices: ['Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
  {
    description: 'trending queries (popular searches)',
    control: '2565-20',
    treatment: '2565-22',
    ks: 'popularSearchesEnabled',
    arm: 'popularSearchesArm2',
    devices: ['Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
  {
    description: 'MEW whitespace removal',
    control: '3086-20',
    treatment: '3086-21',
    ks: 'mewWhitespaceRemovalEnabled',
    devices: ['Mobile'],
    invalidationPrefetch: false,
  },
  {
    description: 'Ask Macys Prompts',
    control: '3233-20',
    treatment: '3233-21',
    ks: 'askMacysPromptsEnabled',
    arm: 'askMacysPromptsArmOne',
    devices: ['Desktop', 'Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
  {
    description: 'Ask Macys Prompts',
    control: '3233-20',
    treatment: '3233-22',
    ks: 'askMacysPromptsEnabled',
    arm: 'askMacysPromptsArmTwo',
    devices: ['Desktop', 'Mobile'],
    invalidationPrefetch: false,
    clientSide: true,
  },
];
